<template>
    <img />
</template>

<script>
export default {
props: {
    src: {
    type: String,
    default: ""
    },
    customClass:{
        type: String,
        default: ""
    },
},

mounted()
{
    let that = this
    fetch(this.src).then(
        async (response)=>{
            let text = await response.text()
            var parser = new DOMParser();
            let HTML = parser.parseFromString(text, 'text/html');
            let svg = HTML.querySelector('svg')
           
            let img = that.$el
            for (let i = 0; i< img.attributes.length; i++)
            {
                if(img.attributes[i]['nodeName'].includes('data-v-'))
                    svg.setAttribute(img.attributes[i]['nodeName'],img.attributes[i]['nodeValue'])
            } 
            // svg.classList = imgClasses
            if(that.customClass)
                svg.classList.add(that.customClass)
            img.replaceWith(svg)
        }
    )
}
}
</script>

<style>

</style>
